import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.8 16.889V4.91c0-1.369 0-2.053-.262-2.576a2.423 2.423 0 0 0-1.048-1.069C15.976 1 15.304 1 13.96 1H4.84c-1.344 0-2.016 0-2.53.266a2.423 2.423 0 0 0-1.048 1.069C1 2.858 1 3.542 1 4.91v8.067c0 1.369 0 2.053.262 2.576.23.46.597.834 1.048 1.068.514.267 1.186.267 2.53.267H17.8Zm0 0h5.28c.672 0 1.008 0 1.265-.133.226-.117.41-.305.524-.535.131-.26.131-.603.131-1.288v-3.345c0-.3 0-.449-.033-.59a1.235 1.235 0 0 0-.144-.353c-.074-.123-.178-.229-.385-.44l-2.476-2.521c-.207-.212-.311-.317-.432-.393a1.187 1.187 0 0 0-.347-.146c-.138-.034-.285-.034-.578-.034H17.8M9.4 19.944C9.4 21.632 8.057 23 6.4 23s-3-1.368-3-3.056c0-1.687 1.343-3.055 3-3.055s3 1.368 3 3.055Zm13.2 0c0 1.688-1.343 3.056-3 3.056s-3-1.368-3-3.056c0-1.687 1.343-3.055 3-3.055s3 1.368 3 3.055Z"
    }, null, -1)
  ])))
}
export default { render: render }